"use client";

import React from "react";
import { Button } from "antd";
import { useRouter } from "next/navigation";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import styles from "./index.module.css";

const StartBuildingButtonContent = () => {
  const router = useRouter();
  const { isAuthenticated } = useAuth();
  const startButtonText = "Start building →";

  return (
    <Button
      type="primary"
      className={styles.startButton}
      onClick={() => router.push(isAuthenticated ? "/dashboard" : "/login")}
    >
      {startButtonText}
    </Button>
  );
};

const StartBuildingButton = () => {
  return (
    <AuthProvider>
      <StartBuildingButtonContent />
    </AuthProvider>
  );
};

export default StartBuildingButton;
